import React, { useEffect, useState } from 'react'
import styles from './Map.module.css'
import { MapContainer, Marker, Popup, TileLayer, useMap, useMapEvents } from 'react-leaflet'
// import "leaflet/dist/leaflet.css"
import './Leaflet.css';
import Control from 'react-leaflet-custom-control'
import L from 'leaflet'
import Button from '../button/Button'
delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

function Map(props) {
    const disabled = props.disabled || false
    const [position, setPosition] = useState(null)
    const [currentPosition, setCurrentPosition] = useState(null)
    const width = props.width || '100%'
    const height = props.height || '100%'

    useEffect(() => {
        if (props.latitude && props.longitude) {
            setPosition([props.latitude, props.longitude])
        }
    }, [props.latitude, props.longitude])


    return (
        <MapContainer
            className={styles.container}
            style={{ width: width, height: height, borderWidth: 1, borderColor: '#A2B5BC', borderRadius: 5 }}
            center={[props.latitude, props.longitude] || [16.824720, 100.259506]}
            zoom={13}
            scrollWheelZoom={true}
        >
            <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {
                props.multipleMarkers ? <>
                    <MultipleMarkers location={props.location} />
                </> :
                    <LocationMarker
                        disabled={disabled}
                        latitude={props.latitude}
                        longitude={props.longitude}
                        onChange={props.onChange}
                        position={position}
                        setPosition={setPosition}
                        setCurrentPosition={setCurrentPosition}
                        nameLab={props.nameLab}
                    />
            }

            {/* <Control>
                <Button onClick={() => {
                    setPosition(currentPosition)
                    props.onChange(currentPosition)
                }}>test</Button>
            </Control> */}

        </MapContainer >
    )
}
function LocationMarker({ disabled, latitude, longitude, onChange, position, setPosition, setCurrentPosition, nameLab }) {

    const map = useMap()
    const mapEvent = useMapEvents({
        click(e) {
            if (!disabled) {
                setPosition(e.latlng)
                onChange(e.latlng)
            }
        },
        locationfound(e) {
            setCurrentPosition(e.latlng)
        },
    })

    useEffect(() => {
        if (latitude && longitude) {
            setPosition([latitude, longitude]);
            map.flyTo([latitude, longitude], map.getZoom());
        } else {
            map.locate().on("locationfound", function (e) {
                setPosition(e.latlng);
                setCurrentPosition(e.latlng)
                onChange(e.latlng)
                map.flyTo(e.latlng, map.getZoom());
                const radius = e.accuracy;
                const circle = L.circle(e.latlng, radius);
                circle.addTo(map);
            });
        }

    }, [map, latitude, longitude]);

    return position === null ? null : (
        <Marker className={styles.marker} position={position}>
            <Popup>{nameLab ? nameLab : JSON.stringify(position)}</Popup>
        </Marker>
    )
}

function MultipleMarkers({ location }) {
    const map = useMapEvents({
        click() {
            map.locate();
        }
    });

    return location?.map((item, idx) => {
        return (
            <Marker key={idx} position={item}>
                {/* icon={new Icon({iconUrl: marker, iconSize: [25, 41], iconAnchor: [12, 41]})} */}
                <Popup>{item['laboratory_name']}</Popup>
            </Marker>
        );
    });
}
export default Map